import LBox from "@components/LBox";
import LText from "@components/LText";
import { fonts } from "@theme";
import { BottomSheetSubmitButton } from "@utils/swmModal/components/BottomSheetPrimitives";
import type { ReactNode } from "react";

/**
 * Accent red for the concert date label. A darker red than the email's brand
 * coral (#DA5263) so it stays legible on the light liquid-glass sheet. No clean
 * theme text token maps to it, so it lives here as a single shared constant.
 */
export const CONCERT_DATE_COLOR = "#DA5263";

/** Section heading — mirrors the email <h2> (20px / bold / near-black). */
export const SectionTitle = ({ children }: { children: ReactNode }) => (
  <LText color="white" fontFamily={fonts.bold} fontSize={20} lineHeight={25}>
    {children}
  </LText>
);

/** Section body copy — mirrors the email description paragraph (14px / 1.7 / #333). */
export const SectionText = ({ children }: { children: ReactNode }) => (
  <LText
    color="subGrey"
    fontFamily={fonts.regular}
    fontSize={14}
    lineHeight={24}
  >
    {children}
  </LText>
);

/**
 * Full-width section CTA — the app's standard white rounded bottom-sheet button
 * (NOT the email's orange gradient, which looks off in-app).
 */
export const InboxSectionCta = ({
  label,
  onPress,
}: {
  label: string;
  onPress: () => void;
}) => (
  <LBox pt="s2">
    <BottomSheetSubmitButton
      label={label}
      marginBottom="zero"
      onPress={onPress}
      sentryEventName="inbox_section_cta"
    />
  </LBox>
);
